// extracted by mini-css-extract-plugin
export default {"itemBox":"itembox_itemBox__2lC2j","descBox":"itembox_descBox__nN1hw","descBoxDivider":"itembox_descBoxDivider__u-ORV","tagline":"itembox_tagline__paSMg"};